/*
  Manchas landing page behaviour (sections/lp-manchas-offer.liquid).
  Vanilla JS replacement for the Claude Design reactive bindings:
  purchase type, salsa picker, prices, hero carousel, FAQ, review
  "Read more", falling chips background and the direct-to-checkout button.
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  /* Format cents with the shop money format; trim=true mimics money_without_trailing_zeros */
  function formatMoney(cents, format, trim) {
    var fmt = format || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount';
    function group(num, dec, thou, sep) {
      var parts = (num / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      var out = parts.join(sep);
      if (trim && dec > 0 && /^0+$/.test(parts[1] || '')) out = parts[0];
      return out;
    }
    var val;
    if (kind === 'amount_no_decimals') val = group(cents, 0, ',', '.');
    else if (kind === 'amount_with_comma_separator') val = group(cents, 2, '.', ',');
    else if (kind === 'amount_no_decimals_with_comma_separator') val = group(cents, 0, '.', ',');
    else if (kind === 'amount_with_apostrophe_separator') val = group(cents, 2, "'", '.');
    else val = group(cents, 2, ',', '.');
    return m ? fmt.replace(m[0], val) : val;
  }

  function rootUrl() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  /* ---------- Hero carousel ---------- */
  function Carousel(card, mode, dots) {
    var slides = [];
    each(card.querySelectorAll('[data-lp-slide]'), function (el) {
      slides[Number(el.getAttribute('data-lp-slide'))] = el;
    });
    var n = slides.length;
    var cur = 0;
    var dir = 1;
    var prevOff = slides.map(function (el, i) {
      return i === n - 1 ? -1 : i;
    });

    function render(instant) {
      slides.forEach(function (el, i) {
        var o;
        var animate = true;
        if (mode === 'a') {
          o = i - cur;
        } else {
          o = (i - cur + n) % n;
          if (o === n - 1) o = -1;
          else if (o === 2) o = dir > 0 ? 2 : -2;
          animate = Math.abs(o - prevOff[i]) <= 1;
          prevOff[i] = o;
        }
        el.style.transition = instant || !animate ? 'none' : '';
        if (mode === 'b' && i === 0) {
          el.style.transform = 'translateX(calc(' + o + ' * (100% + 64px)))';
        } else {
          el.style.transform = 'translateX(' + o * 100 + '%)';
        }
        el.setAttribute('aria-hidden', o === 0 ? 'false' : 'true');
      });
      each(dots, function (d) {
        d.setAttribute('aria-selected', Number(d.getAttribute('data-lp-dot')) === cur ? 'true' : 'false');
      });
      if (instant) {
        void card.offsetWidth;
        slides.forEach(function (el) {
          el.style.transition = '';
        });
      }
    }

    function go(d) {
      cur = (cur + d + n) % n;
      dir = d;
      render(false);
    }

    function jump(i) {
      if (i === cur) return;
      dir = i > cur ? 1 : -1;
      cur = i;
      render(false);
    }

    each(card.querySelectorAll('[data-lp-prev]'), function (b) {
      b.addEventListener('click', function () {
        go(-1);
      });
    });
    each(card.querySelectorAll('[data-lp-next]'), function (b) {
      b.addEventListener('click', function () {
        go(1);
      });
    });
    each(dots, function (d) {
      d.addEventListener('click', function () {
        jump(Number(d.getAttribute('data-lp-dot')));
      });
    });

    var swipeEl = card.matches('[data-lp-swipe]') ? card : card.querySelector('[data-lp-swipe]');
    if (swipeEl) {
      var sx = null;
      swipeEl.addEventListener('pointerdown', function (e) {
        sx = e.clientX;
      });
      swipeEl.addEventListener('pointerup', function (e) {
        if (sx === null) return;
        var dx = e.clientX - sx;
        sx = null;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      });
      swipeEl.addEventListener('pointercancel', function () {
        sx = null;
      });
    }

    render(true);
  }

  /* ---------- Offer A card: scale the 600px design to its column ---------- */
  function fitStage(card) {
    var stage = card.querySelector('[data-lp-stage]');
    if (!stage) return;
    function apply() {
      var w = card.getBoundingClientRect().width;
      if (w) stage.style.setProperty('--e1s', (w / 600).toFixed(4));
    }
    apply();
    if ('ResizeObserver' in window) new ResizeObserver(apply).observe(card);
    window.addEventListener('resize', apply);
  }

  /* Flavor name size on the split card, ported from the LP fit() (variant E1). */
  function fitNames(root) {
    var els = root.querySelectorAll('[data-lp-fit-name]');
    if (!els.length) return;
    var ctx = document.createElement('canvas').getContext('2d');
    if (!ctx) return;
    ctx.font = '900 100px "Golos Text"';
    var W = 600;
    var H = 631;
    var X = 354;
    var B = H - 36;
    var MAX = 336;
    function L(x) {
      return H * (0.74 - ((0.74 - 0.39) * x) / W);
    }
    function maxL(a, b) {
      var m = -1e9;
      for (var k = 0; k <= 12; k++) m = Math.max(m, L(a + ((b - a) * k) / 12));
      return m;
    }
    function measure(t) {
      return ctx.measureText(t).width / 100;
    }
    each(els, function (el) {
      var words = (el.getAttribute('data-lp-fit-name') || '').toUpperCase().split(' ');
      var w1 = measure(words[0] || '');
      var w2 = measure(words.slice(1).join(' '));
      var ww = Math.max(w1, w2);
      var size = 12;
      for (var s = 84; s > 12; s--) {
        if (ww * s > MAX) continue;
        var t2 = B - 0.92 * s;
        var t1 = B - 1.84 * s;
        var tg = t1 - 32;
        if (
          t2 >= maxL(X - w2 * s, X) + 10 &&
          t1 >= maxL(X - w1 * s, X) + 10 &&
          tg >= maxL(X - 110, X) + 10
        ) {
          size = s;
          break;
        }
      }
      el.style.fontSize = size + 'px';
    });
  }

  /* ---------- Falling chips background ---------- */
  function Chips(root, layer, imgs) {
    var CFG = { count: 60, speed: 1.25, size: 1.25, spin: 0.6, sway: 1.45, blur: 1.3, opacity: 0.55 };
    var BASE = [38, 66, 108];
    var SPEED = [36, 68, 120];
    var OPAC = [0.5, 0.8, 1];
    var SWAY = [10, 20, 32];
    var chips = [];
    var raf = null;
    var last = null;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var mobile = vw < 768;
    var reduced = reduceMotion.matches;
    var card = root.querySelector('[data-hero-card]');
    var glows = root.querySelectorAll('[data-glow]');

    function rand(a, b) {
      return a + Math.random() * (b - a);
    }
    function pick() {
      return imgs[(Math.random() * imgs.length) | 0];
    }
    function scale() {
      return CFG.size * (mobile ? 0.65 : 1);
    }
    function target() {
      return mobile ? 25 : CFG.count;
    }
    function spawnX() {
      if (mobile || !card) return Math.random() * vw;
      if (Math.random() < 0.6) return vw / 2 + (Math.random() * vw) / 2;
      var cl = Math.max(0, card.getBoundingClientRect().left);
      return Math.random() < 0.5 && cl > 24 ? Math.random() * cl : (Math.random() * vw) / 2;
    }
    function makeChip(i) {
      var r = (i * 0.6180339887) % 1;
      var lyr = r < 0.45 ? 0 : r < 0.8 ? 1 : 2;
      var el = document.createElement('img');
      el.src = pick();
      el.alt = '';
      el.draggable = false;
      el.decoding = 'async';
      var w = BASE[lyr] * rand(0.75, 1.25);
      el.style.width = w + 'px';
      el.style.zIndex = lyr;
      layer.appendChild(el);
      return {
        el: el,
        layer: lyr,
        w: w,
        x: spawnX(),
        y: rand(-w, vh + w),
        t: rand(0, 100),
        rot: rand(0, 360),
        spinRate: rand(20, 90) * (Math.random() < 0.5 ? -1 : 1),
        swayAmp: SWAY[lyr] * rand(0.6, 1.4),
        swayFreq: rand(0.5, 1.2),
        tiltFreq: rand(0.8, 1.8),
        phase: rand(0, Math.PI * 2),
        jit: rand(0.85, 1.15),
        dim: 1
      };
    }
    function styleChip(c) {
      c.base = CFG.opacity * OPAC[c.layer];
      c.el.style.opacity = c.base * c.dim;
      c.el.style.filter =
        c.layer === 0
          ? 'blur(' + CFG.blur + 'px)'
          : c.layer === 2
          ? 'drop-shadow(0 12px 12px rgba(88,33,17,.28))'
          : 'none';
    }
    function placeStatic() {
      var s = scale();
      chips.forEach(function (c) {
        c.el.style.transform =
          'translate3d(' +
          (Math.random() * vw - c.w / 2) +
          'px,' +
          (Math.random() * vh - c.w / 2) +
          'px,0) rotate(' +
          c.rot +
          'deg) scale(' +
          s +
          ')';
      });
    }
    function sync() {
      var n = target();
      while (chips.length < n) chips.push(makeChip(chips.length));
      while (chips.length > n) chips.pop().el.remove();
      chips.forEach(styleChip);
      if (reduced) placeStatic();
      else frame(0);
    }
    function frame(dt) {
      var s = scale();
      var rects = [];
      each(glows, function (e) {
        var r = e.getBoundingClientRect();
        var p = e.parentElement;
        var cut = p && p.hasAttribute('data-glow-clip') ? p.getBoundingClientRect().top + 60 : -Infinity;
        var box = { left: r.left + 60, right: r.right - 60, top: Math.max(r.top + 60, cut), bottom: r.bottom - 60, cut: cut };
        if (box.bottom > -200 && box.top < vh + 200) rects.push(box);
      });
      var k = dt > 0 ? 1 - Math.exp(-dt * 8) : 1;
      for (var i = 0; i < chips.length; i++) {
        var c = chips[i];
        var half = c.w * s * 0.75;
        c.t += dt;
        c.y += SPEED[c.layer] * CFG.speed * c.jit * dt * (mobile ? 0.8 : 1);
        c.rot += c.spinRate * CFG.spin * dt;
        if (c.y > vh + half + 40) {
          c.y = -half - 40 - Math.random() * vh * 0.25;
          c.x = spawnX();
          c.el.src = pick();
        }
        var sx = Math.sin(c.t * c.swayFreq + c.phase) * c.swayAmp * CFG.sway * s;
        var tilt = 0.82 + 0.18 * Math.cos(c.t * c.tiltFreq * Math.max(CFG.spin, 0.3) + c.phase);
        c.el.style.transform =
          'translate3d(' +
          (c.x + sx - c.w / 2) +
          'px,' +
          (c.y - c.w / 2) +
          'px,0) rotate(' +
          c.rot +
          'deg) scale(' +
          s +
          ',' +
          s * tilt +
          ')';
        var px = c.x + sx;
        var py = c.y;
        var d = Infinity;
        for (var j = 0; j < rects.length; j++) {
          var R = rects[j];
          if (py >= R.cut) {
            d = Math.min(d, Math.hypot(Math.max(R.left - px, 0, px - R.right), Math.max(R.top - py, 0, py - R.bottom)));
          }
        }
        var u = Math.min(1, d / 120);
        var tgt = 0.35 + 0.65 * u * u * (3 - 2 * u);
        var next = c.dim + (tgt - c.dim) * k;
        if (Math.abs(next - c.dim) > 0.003 || dt === 0) {
          c.dim = next;
          c.el.style.opacity = c.base * c.dim;
        }
      }
    }
    function tick(t) {
      var dt = last === null ? 0 : Math.min(0.05, (t - last) / 1000);
      last = t;
      frame(dt);
      raf = requestAnimationFrame(tick);
    }
    function start() {
      if (reduced || raf || document.hidden) return;
      last = null;
      raf = requestAnimationFrame(tick);
    }
    function stop() {
      if (raf) cancelAnimationFrame(raf);
      raf = null;
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });
    window.addEventListener('resize', function () {
      vw = window.innerWidth;
      vh = window.innerHeight;
      var m = vw < 768;
      if (m !== mobile) {
        mobile = m;
        sync();
      } else if (reduced) {
        placeStatic();
      }
    });
    var onMq = function () {
      reduced = reduceMotion.matches;
      stop();
      sync();
      start();
    };
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', onMq);

    sync();
    start();
  }

  /* ---------- Page ---------- */
  function init(root) {
    var cfgEl = root.querySelector('[data-lp-config]');
    if (!cfgEl) return;
    var cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return;
    }
    var state = {
      plan: root.getAttribute('data-plan') || 'one',
      flavor: Number(root.getAttribute('data-flavor')) || 0,
      busy: false
    };
    var plansMap = {};
    var plansEl = root.querySelector('[data-lp-plans]');
    if (plansEl) {
      try {
        plansMap = JSON.parse(plansEl.textContent) || {};
      } catch (e) {
        plansMap = {};
      }
    }
    var form = root.querySelector('form.lp-buy__form');
    var idInput = form && form.querySelector('[data-lp-variant-input]');
    var loopMode = !!cfg.loopMode;
    var errorEl = root.querySelector('[data-lp-error]');
    var checkoutBtn = root.querySelector('[data-lp-checkout]');
    var ctaLabel = root.querySelector('[data-lp-cta-label]');
    var ctaHtml = ctaLabel ? ctaLabel.innerHTML : '';

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }
    function hideError() {
      if (errorEl) errorEl.hidden = true;
    }

    /* Purchase type + prices */
    function setPlan(p) {
      if (p === 'sub' && !cfg.hasSub) p = 'one';
      state.plan = p;
      root.setAttribute('data-plan', p);
      each(root.querySelectorAll('[data-lp-plan]'), function (b) {
        var on = b.getAttribute('data-lp-plan') === p;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var d = cfg.plans[p];
      each(root.querySelectorAll('[data-lp-price]'), function (el) {
        el.textContent = d.price;
      });
      each(root.querySelectorAll('[data-lp-perbag]'), function (el) {
        el.textContent = d.perBag;
      });
      each(root.querySelectorAll('[data-lp-save]'), function (el) {
        el.textContent = d.save;
        var pill = el.closest('.lp-save');
        if (pill) pill.hidden = !(d.saveCents > 0);
      });
    }
    each(root.querySelectorAll('[data-lp-plan]'), function (b) {
      b.addEventListener('click', function () {
        setPlan(b.getAttribute('data-lp-plan'));
      });
    });

    /* Salsa flavor (buy box, hero card and Saucy section stay in sync) */
    function flavorInfo(i) {
      var sw = root.querySelector('.lp-saucy__sw[data-lp-flavor-pick="' + i + '"]');
      var bb = root.querySelector('.lp-swatch[data-lp-flavor-pick="' + i + '"]');
      return {
        name: (sw && sw.getAttribute('data-name')) || (bb && bb.getAttribute('data-name')) || '',
        fill: sw && sw.getAttribute('data-fill'),
        ink: sw && sw.getAttribute('data-jar-ink')
      };
    }
    /* Loop mode: price texts follow the variant + selling plan Loop writes into the form */
    function loopSelection() {
      var vid = idInput ? idInput.value : String(cfg.variantId);
      var entry = plansMap[vid] || plansMap[String(cfg.variantId)];
      var sp = form ? new FormData(form).get('selling_plan') : null;
      sp = sp ? String(sp) : '';
      var cents = entry ? entry.one : cfg.plans.one.cents;
      var onPlan = false;
      if (sp && entry && entry.plans && entry.plans[sp] != null) {
        cents = entry.plans[sp];
        onPlan = true;
      }
      var compare = entry ? entry.compare : 0;
      return { variantId: Number(vid), sellingPlan: sp, subscribed: onPlan || !!sp, cents: cents, save: compare - cents };
    }
    /* Only write when the text differs, so a MutationObserver never loops on our own updates */
    function setText(el, t) {
      if (el.textContent !== t) el.textContent = t;
    }
    function renderLoopPrices() {
      if (!loopMode) return;
      var sel = loopSelection();
      var price = formatMoney(sel.cents, cfg.moneyFormat, true);
      var perBag = formatMoney(Math.round(sel.cents / (cfg.bags || 1)), cfg.moneyFormat, false);
      var save = formatMoney(Math.max(sel.save, 0), cfg.moneyFormat, true);
      if (!state.busy) {
        each(root.querySelectorAll('[data-lp-price]'), function (el) {
          setText(el, price);
        });
      }
      each(root.querySelectorAll('[data-lp-perbag]'), function (el) {
        setText(el, perBag);
      });
      each(root.querySelectorAll('[data-lp-save]'), function (el) {
        setText(el, save);
        var pill = el.closest('.lp-save');
        var hide = !(sel.save > 0);
        if (pill && pill.hidden !== hide) pill.hidden = hide;
      });
    }

    /* Keep the product form (and the URL) on the chosen variant so app blocks follow it */
    function syncFormVariant(variantId) {
      if (!variantId) return;
      cfg.variantId = variantId;
      if (idInput && String(idInput.value) !== String(variantId)) {
        idInput.value = variantId;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {}
      renderLoopPrices();
    }

    function setFlavor(i) {
      state.flavor = i;
      root.setAttribute('data-flavor', i);
      hideError();
      each(root.querySelectorAll('[data-lp-flavor-pick]'), function (b) {
        var on = Number(b.getAttribute('data-lp-flavor-pick')) === i;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      each(root.querySelectorAll('[data-lp-flavor-layer]'), function (el) {
        var on = Number(el.getAttribute('data-lp-flavor-layer')) === i;
        el.classList.toggle('is-on', on);
        if (el.classList.contains('lp-split__side')) el.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      var info = flavorInfo(i);
      each(root.querySelectorAll('[data-lp-flavor-name]'), function (el) {
        el.textContent = info.name;
      });
      var jar = root.querySelector('[data-lp-jar]');
      if (jar && info.fill) {
        jar.style.setProperty('--jar-label', info.fill);
        jar.style.setProperty('--jar-label-text', info.ink || '#582111');
      }
      if (cfg.offer === 'a') {
        var picked = root.querySelector('.lp-swatch[data-lp-flavor-pick="' + i + '"]');
        var vid = picked && Number(picked.getAttribute('data-variant-id'));
        if (vid) syncFormVariant(vid);
      }
    }
    each(root.querySelectorAll('[data-lp-flavor-pick]'), function (b) {
      b.addEventListener('click', function () {
        setFlavor(Number(b.getAttribute('data-lp-flavor-pick')));
      });
    });

    /* Arrow-key support inside the radio groups */
    each(root.querySelectorAll('[role="radiogroup"]'), function (group) {
      group.addEventListener('keydown', function (e) {
        var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        if (!(e.key in keys)) return;
        var radios = Array.prototype.filter.call(group.querySelectorAll('[role="radio"]'), function (r) {
          return !r.disabled;
        });
        var idx = radios.indexOf(document.activeElement);
        if (idx < 0) return;
        e.preventDefault();
        var next = radios[(idx + keys[e.key] + radios.length) % radios.length];
        next.focus();
        next.click();
      });
    });

    /* Hero carousel */
    var card = root.querySelector('[data-lp-carousel]');
    if (card) {
      var mode = card.getAttribute('data-lp-carousel');
      if (mode === 'a') fitStage(card);
      Carousel(card, mode, root.querySelectorAll('[data-lp-dot]'));
    }
    fitNames(root);
    if (document.fonts) {
      document.fonts.ready.then(function () {
        fitNames(root);
      });
      if (document.fonts.addEventListener) {
        document.fonts.addEventListener('loadingdone', function () {
          fitNames(root);
        });
      }
    }

    /* FAQ accordion: one open at a time */
    var faqItems = root.querySelectorAll('.lp-faq__item');
    each(root.querySelectorAll('[data-lp-faq]'), function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.lp-faq__item');
        var willOpen = !item.classList.contains('is-open');
        each(faqItems, function (it) {
          var open = willOpen && it === item;
          it.classList.toggle('is-open', open);
          var q = it.querySelector('[data-lp-faq]');
          var a = it.querySelector('.lp-faq__a');
          if (q) q.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (a) a.hidden = !open;
        });
      });
    });

    /* Reviews: clamp to 4 lines with a Read more link */
    var quotes = root.querySelectorAll('[data-lp-quote]');
    function measureQuotes() {
      each(quotes, function (q) {
        var more = q.parentElement.querySelector('[data-lp-more]');
        if (!more) return;
        if (!q.classList.contains('is-clamped')) {
          more.hidden = true;
          return;
        }
        more.hidden = !(q.scrollHeight > q.clientHeight + 1);
      });
    }
    each(root.querySelectorAll('[data-lp-more]'), function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var q = a.parentElement.querySelector('[data-lp-quote]');
        if (q) q.classList.remove('is-clamped');
        a.hidden = true;
      });
    });
    measureQuotes();
    window.addEventListener('resize', measureQuotes);
    if (document.fonts) document.fonts.ready.then(measureQuotes);

    /* Closing button scrolls back to the top */
    each(root.querySelectorAll('[data-lp-top]'), function (b) {
      b.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      });
    });

    /* Checkout: clear cart, add the box (+ salsa), go straight to checkout */
    function setBusy(on) {
      state.busy = on;
      if (!checkoutBtn) return;
      checkoutBtn.disabled = on;
      checkoutBtn.classList.toggle('is-loading', on);
      checkoutBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (ctaLabel) {
        if (on) {
          ctaLabel.textContent = cfg.loadingLabel || '...';
        } else {
          ctaLabel.innerHTML = ctaHtml;
          var d = cfg.plans[state.plan];
          each(ctaLabel.querySelectorAll('[data-lp-price]'), function (el) {
            el.textContent = d.price;
          });
          renderLoopPrices();
        }
      }
    }

    function post(url, body) {
      /* Native fetch saved in layout/lp.liquid before app scripts load, so cart apps
         (Rebuy Smart Cart) don't see the add and flash their drawer before checkout. */
      var doFetch = window.__lpNativeFetch || window.fetch.bind(window);
      return doFetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body || {})
      }).then(function (res) {
        if (res.ok) return res.json();
        return res
          .json()
          .catch(function () {
            return {};
          })
          .then(function (j) {
            throw new Error(j.description || j.message || 'Request failed (' + res.status + ')');
          });
      });
    }

    function checkout() {
      if (state.busy || !cfg.available || !cfg.variantId) return;
      hideError();
      var plan = cfg.plans[state.plan];
      var variantId = Number(cfg.variantId);

      /* Offer A: each salsa is a variant of the box, so the chosen swatch is the box variant */
      if (cfg.offer === 'a') {
        var sw = root.querySelector('.lp-swatch[data-lp-flavor-pick="' + state.flavor + '"]');
        variantId = sw && !sw.disabled && Number(sw.getAttribute('data-variant-id'));
        if (!variantId) {
          showError(cfg.salsaRequired);
          return;
        }
      }

      var box = { id: variantId, quantity: 1 };
      var subscribed = state.plan === 'sub';
      var valueCents = plan.cents;
      if (loopMode) {
        /* Loop widget mode: the selling plan comes from the form */
        var sel = loopSelection();
        if (cfg.offer !== 'a' && sel.variantId) box.id = sel.variantId;
        if (sel.sellingPlan) box.selling_plan = Number(sel.sellingPlan);
        subscribed = !!sel.sellingPlan;
        valueCents = sel.cents;
      } else if (subscribed && plan.sellingPlan) {
        box.selling_plan = Number(plan.sellingPlan);
      }
      var items = [box];

      setBusy(true);
      var base = rootUrl();
      post(base + 'cart/clear.js')
        .then(function () {
          return post(base + 'cart/add.js', { items: items });
        })
        .then(function () {
          if (window.dataLayer && typeof window.dataLayer.push === 'function') {
            window.dataLayer.push({
              event: 'lp_get_my_box',
              offer: cfg.offer,
              purchase_type: subscribed ? 'subscription' : 'one_time',
              value: valueCents / 100
            });
          }
          window.location.href = base + 'checkout';
        })
        .catch(function (err) {
          if (window.console) console.error('[lp-manchas] checkout failed:', err);
          setBusy(false);
          showError(cfg.errorMessage);
        });
    }
    if (checkoutBtn) checkoutBtn.addEventListener('click', checkout);

    /* The product form never submits normally: Enter goes through checkout() */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        checkout();
      });
      if (loopMode) {
        var rerender = function () {
          renderLoopPrices();
        };
        form.addEventListener('change', rerender);
        form.addEventListener('input', rerender);
        /* Loop may set its hidden selling_plan input without firing events */
        form.addEventListener('click', function () {
          setTimeout(rerender, 0);
        });
        if ('MutationObserver' in window) {
          /* React to the widget adding or updating inputs, never to our own button text */
          new MutationObserver(function (records) {
            for (var r = 0; r < records.length; r++) {
              if (!checkoutBtn || !checkoutBtn.contains(records[r].target)) {
                rerender();
                return;
              }
            }
          }).observe(form, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['value', 'checked']
          });
        }
        renderLoopPrices();
        /* Catch a default plan the widget sets silently while it boots */
        [300, 1000, 2500, 5000].forEach(function (t) {
          setTimeout(rerender, t);
        });
      }
    }

    /* Coming back from checkout with the back button restores a usable button */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && state.busy) setBusy(false);
    });

    /* Falling chips */
    var layer = root.querySelector('[data-lp-chips]');
    if (layer && cfg.chips && cfg.chips.length) Chips(root, layer, cfg.chips);
  }

  each(document.querySelectorAll('[data-lp]'), init);
})();
